import React, { PureComponent } from "react";
import Classnames from "classnames";
import { checkIfMobile } from "../../utils";
import "./Toggle.scss";

interface Props {
  selectedCategory: string;
  categories: [string, string];
  setCategory: Function;
}

class Toggle extends PureComponent<Props> {
  render() {
    const { categories, selectedCategory, setCategory } = this.props;

    return (
      <div className="Toggle">
        {categories.map((d, i) => (
          <div
            key={d}
            className={Classnames("category-" + i, {
              selected: d === selectedCategory,
              "tall-toggle": d.length > 20,
            })}
          >
            {checkIfMobile() ? d.replace("/", "/ ") : d}
          </div>
        ))}
        <label className="switch">
          <input
            readOnly
            type="checkbox"
            tabIndex={-1}
            // below will give it the attribute checked, controlling toggle position
            checked={categories[1] === selectedCategory}
            onClick={() =>
              setCategory(categories.find(d => d !== selectedCategory))
            }
          />
          <span className="slider round"> </span>
        </label>
      </div>
    );
  }
}

export default Toggle;
